export default __webpack_public_path__ + "static/media/G89A3675.2bbe7768.jpg";